module.exports = __webpack_public_path__ + "img/U.213b41b4.png";